import { render } from "./Tag.vue?vue&type=template&id=eec4279c&scoped=true&ts=true"
import script from "./Tag.vue?vue&type=script&lang=ts"
export * from "./Tag.vue?vue&type=script&lang=ts"

import "./Tag.vue?vue&type=style&index=0&id=eec4279c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eec4279c"]])

export default __exports__